var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClubEntel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.97 0.717784C22.5498 -0.230997 23.9243 -0.241144 24.518 0.698972L33.1546 14.3735L46.7325 16.5174C47.8604 16.6955 48.3836 18.0185 47.6825 18.9198L37.6046 31.8772L40.4698 46.2032C40.7119 47.4141 39.469 48.3825 38.3541 47.8516L23.2835 40.6751L9.69926 47.8247C8.5819 48.4127 7.28226 47.4413 7.52989 46.2032L10.3951 31.8772L0.317142 18.9198C-0.358873 18.0507 0.100836 16.7736 1.17572 16.5348L14.0528 13.6732L21.97 0.717784ZM23.2709 4.34201L15.9479 16.3251L4.1402 18.949L13.6059 31.1192L11.0891 43.7032L23.2163 37.3205L36.9411 43.8561L34.3937 31.1192L43.7543 19.0842L31.3441 17.1247L23.2709 4.34201Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClubEntel);
export default __webpack_public_path__ + "static/media/club_entel.c8d9ef49d6e75dde8c47e360738c15e3.svg";
export { ForwardRef as ReactComponent };